import React, { useEffect, useMemo, useCallback, useState } from 'react'
import { Text } from 'rebass'
import styled from 'styled-components'
import { provider } from 'web3-core'
import { Contract } from 'web3-eth-contract'
import { useTranslation } from 'react-i18next'
import { BigNumber } from 'bignumber.js'

import { getContract } from '../../utils/bakery/erc20'
import { ButtonConfirmed } from '../../components/Button'
import { ButtonPrimary } from '../../components/Button'
import WithdrawModal from './components/WithdrawModal'
import DepositModal from './components/DepositModal'
import { RouteComponentProps } from 'react-router-dom'
import {
  getMasterChefContract,
  getTenPetNftMasterContract,
  getTenPetNftMasterAddress,
  getErc721Balance,
  getWeaponInfo,
  getPetNftAddress,
  getNftHelperContract,
  getMasterChef2Contract
} from '../../sushi/utils'
import { getHelmetInfo } from '../../utils/lib/utils'
import { getBalanceNumber } from '../../utils/bakery/formatBalance'
import Loading from '../../components/Loader/Loading'
import Value from '../../components/Value'
import { getPetImageUrl } from '../../utils/func'
import { PET_BASE_URL } from '../../constants/pets'

// // hooks
import { useWalletModalToggle } from '../../state/application/hooks'
import { useActiveWeb3React } from '../../hooks'
import useTokenBalance from '../../hooks/bakery/useTokenBalance'
import useFarm from '../../hooks/bakery/useFarm'
import useModal from '../../hooks/bakery/useModal'
import useYam from '../../hooks/bakery/useYam'
import useStake from '../../hooks/bakery/useStake'
import useUnstake from '../../hooks/bakery/useUnstake'
import useStakedBalance from '../../hooks/bakery/useStakedBalance'
import useApprove from '../../hooks/bakery/useApprove'
import useAllowance from '../../hooks/bakery/useAllowance'
import useNftInfo from '../../hooks/bakery/useNftInfo'
import useBlock from '../../hooks/bakery/useBlock'
import useReward from '../../hooks/bakery/useReward'
import { useWeaponNftContract, useHelmetNftContract } from '../../hooks/pets/useContract'

import { getPets } from '../../service/nft'

import { MINTTOKEN } from '../../constants/bakery'

const AmountElement = styled(Text)`
  color: #2a3567;
  font-size: 30px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
      font-size: 25px;
  `};
  & > div > span {
    color: #2a3567;
  }
`

const LoginBtn = styled(ButtonPrimary)`
  margin: 54px auto 0;
  width: initial;
  padding: 8px 16px;
`
const LoginBtnWrapper = styled.div``
const BodyBox = styled.div`
  background-color: ${({ theme }) => theme.bsBg10};
  border-radius: 40px;
  overflow: hidden;
`
const BodyCard = styled.div<{ backgroundImg: string }>`
  width: 616px;
  padding: 120px 98px 53px;
  background: url(${({ backgroundImg }) => (backgroundImg ? backgroundImg : '')});
  background-color: #f9d147;
  background-repeat: no-repeat;
  background-size: 100%;
  text-align: center;
  ${({ theme }) => theme.mediaWidth.upToSmall`
      width: 320px;
      padding: 24px 22px 53px;
  `};
`
const TitleText = styled(Text)`
  font-family: Baloo Da;
  color: #2a3567;
  margin-right: 6px;
  font-size: 20px;
`
const BalanceCard = styled.div`
  padding: 17px 0 27px;
  border-radius: 30px;
  margin: 0 24px;
`
const BalanceTop = styled.div`
  height: 51px;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const BalanceBtn = styled.div`
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`
const Button = styled(ButtonPrimary)`
  border: none;
  font-size: 12px;
  width: 172px;
  height: 32px;
  padding: 0;
  margin-top: 10px;
  background-color: #da4550;
  border: 1px solid #2a3567;
  background-size: 100%;
  &:hover {
    background-color: #da4550;
  }
`
const Harvest = styled.div`
  margin: 0 24px;
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-wrap: wrap;
    justify-content: center;
  `};
`
const CurrencyImg = styled.div`
  width: 126px;
  height: 126px;
  background-color: #f8b52e;
  border-radius: 18px;
  margin-right: 24px;
  padding-top: 10px;
  background-image: url('/images/petsNft/ellipse_shadow.svg');
  background-repeat: no-repeat;
  background-position: bottom 8px center;
  background-size: 76px 20px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-bottom: 30px;
    margin-right: 0px;
  `};
`
const Info = styled.div`
  flex: 1;
  white-space: nowrap;
  position: relative;
  min-height: 126px;
`
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  color: #2a3567;
`
const HarvestBtn = styled(ButtonConfirmed)`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 32px;
  margin-top: 13px;
  font-size: 14px;
  overflow: hidden;
  background-size: 100%;
  background-color: #f9d147;
  border: 1px solid #2a3567;
  -webkit-text-stroke: 1px #da4550;
  &:disabled {
    background-color: #f9d147;
    border: 1px solid #2a3567;
  }
`
const ProgressBar = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #da4550;
  border-radius: 10px;
  max-width: 100%;
`
const ProgressTime = styled.span`
  position: relative;
`

const FishDecoration = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 33px 24px 25px;
`
const FishDecorationLine = styled.div`
  flex-grow: 1;
  height: 1px;
  background: #2a3567;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f9d147;
  border-radius: 40px;
  overflow: hidden;
  margin-top: 12px;
  padding: 32px 0;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `}
`
const Title = styled.div`
  color: ${({ theme }) => theme.primary1};
  margin: 0 0 16px;
  font-family: Yuanti SC;
  font-size: 18px;
  font-weight: 700;
`
const Title1 = styled(Title)`
  margin: 32px 0 26px;
`
const ImgEgg = styled.img`
  width: 157px;
  height: auto;
  margin-bottom: 25px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-bottom: 16px;
  `}
`

function getTimeLocale(time: number) {
  const d = Math.floor(time / 60 / 60 / 24)
  const h = Math.floor((time - d * 24 * 3600) / 3600)
  const m = Math.floor((time - d * 24 * 3600 - h * 3600) / 60)
  const s = time - d * 24 * 3600 - h * 3600 - m * 60
  const maps = [
    [d, 'days'],
    [h, 'hours'],
    [m, 'mins'],
    [s, 's']
  ]
  const index = maps.findIndex(item => !!item[0])
  return maps
    .splice(index, maps.length)
    .map(item => item.join(' '))
    .join(' ')
}

export default function Tenstake({
  match: {
    params: { earn, bakeryId }
  },
  history
}: RouteComponentProps<{ earn?: string; bakeryId?: string }>) {
  let earnType: any
  earnType = earn
  const { active, account, library, chainId } = useActiveWeb3React()
  const { t } = useTranslation()
  const toggleWalletModal = useWalletModalToggle()
  const ethereum = library?.provider
  const {
    pid,
    lpToken,
    lpTokenAddress,
    // tokenAddress,
    earnToken
    // name,
    // icon,
    // activityTime,
    // stakeIcon,
    // otherName
  } = useFarm(bakeryId, earnType) || {
    pid: 0,
    lpToken: '',
    lpTokenAddress: '',
    tokenAddress: '',
    earnToken: '',
    name: '',
    icon: '',
    activityTime: '',
    stakeIcon: '',
    otherName: ''
  }

  useEffect(() => {
    if (!pid || !earnType || [MINTTOKEN.TEN].indexOf(earnType) < 0) {
      history.push(`/bakery`)
    }
  }, [earnType, pid, history])

  const lpTokenName = useMemo(() => {
    return lpToken.toUpperCase()
  }, [lpToken])

  const earnTokenName = useMemo(() => {
    return earnToken.toUpperCase()
  }, [earnToken])

  const lpContract = useMemo(() => {
    return getContract(ethereum as provider, lpTokenAddress)
  }, [ethereum, lpTokenAddress])

  const sushi = useYam()
  const [loadingFlag, setLoadingFlag] = useState(true)
  const [titleText, setTitle] = useState<any>()
  const [petInfo, setPetInfo] = useState<any>()
  const [noText, setNoText] = useState<any>()
  const [noImg, setNoImg] = useState<any>()
  const weaponNft = useWeaponNftContract()
  const helmetNft = useHelmetNftContract()

  const fetchNftId = useCallback(async () => {
    let balanceArr: any = []
    switch (earnTokenName) {
      case MINTTOKEN.TEN:
        setTitle('Earn PET NFT')
        const nftHelper = getNftHelperContract(sushi)
        const petNftAddress = getPetNftAddress(sushi)
        const petMaster2 = getTenPetNftMasterAddress(sushi)
        balanceArr = await getErc721Balance(nftHelper, petNftAddress, petMaster2)
        if (!balanceArr.length) {
          setNoText('There’s no pet nft')
          setNoImg('/images/petsNft/unknown-pets.png')
          return
        }
        const param = {
          ids: balanceArr[0]
        }
        getPets(chainId as number, param, async (err: any, data: any) => {
          if (err) return
          if (data.code !== 0) return
          const firstPet = data.data.list[0]
          const weapon = firstPet.weapon && weaponNft ? await getWeaponInfo(weaponNft, firstPet.weapon) : undefined
          const helmet = firstPet.helmet && helmetNft ? await getHelmetInfo(helmetNft, +firstPet.helmet) : undefined
          const petUrl = getPetImageUrl({
            petType: firstPet.petType,
            weaponType: weapon ? weapon.weaponType.toString() : 0,
            weaponLevel: weapon ? weapon.level.toString() : 0,
            helmetType: helmet ? helmet.helmetType.toNumber() + 1 : 0,
            helmetLevel: helmet ? helmet.level.toNumber() : 0
          })
          const pets = {
            tokenId: firstPet.id.toString(),
            name: firstPet.name,
            ...(firstPet.price ? { price: Number(firstPet.price) } : {}),
            petToGet:
              new BigNumber(firstPet.petToGet).integerValue(BigNumber.ROUND_FLOOR).toNumber() +
              (weapon ? new BigNumber(+weapon.petToGet).div(new BigNumber(10).pow(18)).toNumber() : 0),
            bakeToGet:
              new BigNumber(firstPet.bakeToGet).integerValue(BigNumber.ROUND_FLOOR).toNumber() +
              (weapon ? new BigNumber(+weapon.bakeToGet).div(new BigNumber(10).pow(18)).toNumber() : 0),
            battlePower: new BigNumber(firstPet.battlePower.toString()).integerValue(BigNumber.ROUND_FLOOR).toNumber(),
            imgUrl: process.env.REACT_APP_PETS_URL + PET_BASE_URL + petUrl,
            level: weapon ? weapon.level.toString() : 0
          }
          setPetInfo(pets)
        })
        break
    }
  }, [chainId, sushi, helmetNft, weaponNft, earnTokenName])

  useEffect(() => {
    fetchNftId()
  }, [fetchNftId])

  let masterContract: Contract
  switch (earnTokenName) {
    case MINTTOKEN.TEN:
      masterContract = getTenPetNftMasterContract(sushi)
      break
    case MINTTOKEN.BAKEV2:
      masterContract = getMasterChef2Contract(sushi)
      break
    default:
      masterContract = getMasterChefContract(sushi)
  }

  const [cutdown, setCutdown] = useState<any>()
  const [timeUp, setTimeUp] = useState<any>()
  const [barWidth, setBarWidth] = useState<any>()
  const nowBlock = useBlock()
  const obtext = useNftInfo(masterContract, lpTokenAddress)
  const fetchNftInfo = useCallback(
    async (first?: boolean) => {
      if (!nowBlock) {
        return
      }
      const info = await obtext()
      Object.keys(info).forEach(key => {
        if (key.toLowerCase() === lpTokenAddress.toLowerCase()) {
          const nowInfo = info[key]
          if (nowInfo) {
            const time = (+nowInfo.rewardMintMinBlockNumbers - nowBlock) * 3
            const timeUp =
              +nowInfo.rewardMintMinBlockNumbers <= nowBlock && +nowInfo.rewardMintMinBlockNumbers !== 0 ? true : false
            const barWidth = +nowInfo.rewardMintMinBlockNumbers
              ? ((nowBlock - +nowInfo.lastUpdateBlock) /
                  (+nowInfo.rewardMintMinBlockNumbers - +nowInfo.lastUpdateBlock)) *
                  100 +
                '%'
              : '0%'
            const cutdown = getTimeLocale(time)
            setCutdown(cutdown)
            setTimeUp(timeUp)
            setBarWidth(barWidth)
            if (+nowInfo.poolRewardStartBlock > nowBlock) {
              setTimeUp(false)
              setBarWidth('0%')
            }
          }
        }
      })
    },
    [nowBlock, lpTokenAddress, obtext]
  )
  useEffect(() => {
    if (account) {
      fetchNftInfo(true)
    }
  }, [account, fetchNftInfo])

  useEffect(() => {
    setLoadingFlag(nowBlock && cutdown ? false : true)
  }, [nowBlock, cutdown])

  const { onReward } = useReward(lpTokenAddress, MINTTOKEN.TENNFT)

  const [requestedApproval, setRequestedApproval] = useState(false)
  const allowance = useAllowance(lpContract, masterContract)
  const { onApprove } = useApprove(lpContract, masterContract)
  const handleApprove = useCallback(async () => {
    try {
      setRequestedApproval(true)
      const txHash = await onApprove()
      // user rejected tx or didn't go thru
      if (!txHash) {
        setRequestedApproval(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApprove, setRequestedApproval])
  const stakedBalance = useStakedBalance(lpTokenAddress, masterContract)
  const tokenBalance = useTokenBalance(lpContract.options.address)
  const { onStake } = useStake(lpTokenAddress, masterContract)
  const { onUnstake } = useUnstake(lpTokenAddress, masterContract)
  const [onPresentWithdraw] = useModal(
    <WithdrawModal max={stakedBalance} onConfirm={onUnstake} tokenName={lpTokenName} />
  )
  const [onPresentDeposit] = useModal(<DepositModal max={tokenBalance} onConfirm={onStake} tokenName={lpTokenName} />)

  if (!pid) {
    return null
  }

  return (
    <>
      <Loading open={loadingFlag} />
      {!(active && account) ? (
        <LoginBtnWrapper>
          <LoginBtn onClick={toggleWalletModal}>{t('Connect to a wallet')}</LoginBtn>
        </LoginBtnWrapper>
      ) : (
        <>
          <BodyBox>
            <BodyCard backgroundImg={'/images/bakery/ten_card_bg.png'}>
              <TitleText>{titleText}</TitleText>
              <BalanceCard>
                <BalanceTop>
                  <img src="/images/bakery/icon_staketen.svg" style={{ width: 30, height: 30 }} alt="" />
                  <AmountElement fontWeight={700}>
                    <Value value={getBalanceNumber(stakedBalance)} />
                  </AmountElement>
                </BalanceTop>
                {!allowance.toNumber() ? (
                  <BalanceBtn>
                    <Button disabled={requestedApproval} onClick={handleApprove}>{`Approve ${lpTokenName}`}</Button>
                  </BalanceBtn>
                ) : (
                  <>
                    <BalanceBtn>
                      <Button
                        style={{
                          marginRight: 16,
                          background: '#F9D147',
                          border: '1px solid #2A3567',
                          color: '#AC562A'
                        }}
                        onClick={onPresentWithdraw}
                      >
                        Unstake
                      </Button>
                      <Button disabled={!petInfo} onClick={onPresentDeposit}>
                        Stake
                      </Button>
                    </BalanceBtn>
                  </>
                )}
              </BalanceCard>
              <FishDecoration>
                <FishDecorationLine></FishDecorationLine>
                <img src="/images/bakery/icon_scoop_drak.svg" alt="" style={{ marginLeft: 15, marginRight: 15 }} />
                <FishDecorationLine></FishDecorationLine>
              </FishDecoration>
              {petInfo ? (
                <>
                  <Harvest>
                    <CurrencyImg>
                      <img width={90} height={90} src={petInfo.imgUrl} alt="" />
                    </CurrencyImg>
                    <Info>
                      <Row style={{ marginBottom: 14 }}>
                        <Text fontWeight={700} fontSize={18}>
                          {petInfo.name}
                        </Text>
                        <Text fontWeight={700} fontSize={18}>
                          {'LV ' + petInfo.level}
                        </Text>
                      </Row>
                      {petInfo.battlePower ? (
                        <Row>
                          <Text fontSize={14}>Battle Power:</Text>
                          <Text fontWeight={700} fontSize={16}>
                            {petInfo.battlePower}
                          </Text>
                        </Row>
                      ) : null}
                      {petInfo.stakingPower ? (
                        <Row>
                          <Text fontSize={14}>Staking Power:</Text>
                          <Text fontWeight={700} fontSize={16}>
                            {petInfo.stakingPower}
                          </Text>
                        </Row>
                      ) : null}
                      {petInfo.petToGet ? (
                        <Row>
                          <Text fontSize={14}>PET to get after abandon:</Text>
                          <Text fontWeight={700} fontSize={16}>
                            {petInfo.petToGet}
                          </Text>
                        </Row>
                      ) : null}
                      <HarvestBtn
                        disabled={!timeUp}
                        onClick={async () => {
                          await onReward()
                        }}
                      >
                        <ProgressBar style={{ width: barWidth }}></ProgressBar>
                        <ProgressTime>{timeUp || barWidth === '0%' ? 'Harvest' : cutdown}</ProgressTime>
                      </HarvestBtn>
                    </Info>
                  </Harvest>
                </>
              ) : (
                <Wrapper>
                  <Title1>{noText}</Title1>
                  {noImg ? <ImgEgg src={noImg} alt="unknown-pets" /> : <></>}
                </Wrapper>
              )}
            </BodyCard>
          </BodyBox>
        </>
      )}
    </>
  )
}
